import { PROTECTED } from '@/lib/constants/routes';

/** Lista delle macchine (rotta `routes/protected/_layout/machines`). */
export const MACHINES_ROUTE: string = `${PROTECTED}/machines`;

/** Scadenze tecniche (pagina del modulo verifiche). */
export const MACHINE_CHECKS_ROUTE: string = `${PROTECTED}/machine-checks`;

export const machineDetailRoute = (id: string): string =>
  `${MACHINES_ROUTE}/${id}`;

/**
 * Cliente proposto nella creazione (`/machines/new?customerId=`). Non è
 * `companyId`, che sulla stessa rotta è il filtro della lista: aprire la
 * creazione dalla scheda cliente filtrerebbe anche l'elenco sotto.
 */
export const NEW_MACHINE_CUSTOMER_PARAM = 'customerId';
